export default [
  {
    name: 'CommentCheck',
    path: '/commentCheck/:topicId',
    component: () =>
      import(
        /* webpackChunkName: "CommentCheck" */ '@/pages/commentCheck/index.vue'
      ),
    meta: {
      title: '评论审核'
    }
  }
]
